import { CommodityDetail } from "features/contracts/enums/commodityDetail";
import { Month as MonthEnum } from "features/shared/enums/monthEnum";
import { BoolEnum } from "./boolEnum";
import { ReservedCapacityChangePeriod } from "features/requirements/enums/reservedCapacityChangePeriod";

export const EnumsMap: Record<string, object>  = {
  CommodityDetail: CommodityDetail,
  MonthEnum: MonthEnum,
  BoolEnum: BoolEnum,
  ReservedCapacityChangePeriod: ReservedCapacityChangePeriod
}